import React, { useState, useCallback, useEffect, useContext } from "react";
import ConfigurationDetails from "./ConfigurationDetails.js";
import ConfigurationPanel from "./ConfigurationPanel.js";
import classes from "./configuration.module.css";
import { getConfig, saveConfig } from "../../services/configuration-service.js";
import { useDispatch, useSelector } from "react-redux";
import { displayToast } from "../../framework/toast/toastUtils";
import {
  getStringValue,
  isEmpty,
  isValidPhoneNumber,
} from "../../utils/utils.js";
import { getISODateTime } from "../../utils/momentUtils.js";
import _ from "lodash";
import GlobalContext from "../../framework/GlobalContext.js";
import moment from "moment";
import { configSavePayload } from "./configurationUtils.js";
import Modal from "../../framework/modal/Modal.js";
import Button from "../../framework/Button.js";
import Aggrid from "../../framework/AgGrid.js";
import ConfigurationContext from "./ConfigurationContext.js";

const Configuration = () => {
  const { activeConfigTab, props, configData } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer.activeTabIndex]
  );
  const [formState, setFormState] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState({});
  const [activeConfigItem, setActiveConfigItem] = useState(activeConfigTab);
  const { formLabels } = useContext(ConfigurationContext);
  const {
    showSpotlight,
    showHealthCards,
    autocompleteOpen,
    commonModalOpen,
    setShowLoading,
  } = useContext(GlobalContext);
  const dispatch = useDispatch();

  const changedColDefs = [
    { headerName: "Section", field: "section", flex: 1 },
    { headerName: "Config Name", field: "name", flex: 3 },
    {
      headerName: "Old Value",
      field: "old_value",
      flex: 1,
      valueFormatter: (params) =>
        typeof params.data.oldValue === "boolean"
          ? params.data.oldValue === true
            ? "Yes"
            : "No"
          : params.data.oldValue,
    },
    {
      headerName: "New Value",
      field: "new_value",
      flex: 1,
      valueFormatter: (params) =>
        typeof params.data.newValue === "boolean"
          ? params.data.newValue === true
            ? "Yes"
            : "No"
          : params.data.newValue,
    },
  ];

  //same method is in Home.js
  const dispatchConfigState = useCallback(
    (newState) => {
      dispatch({
        type: "set_config_data",
        payload: newState,
      });
    },
    [dispatch]
  );
  const getConfigDetails = useCallback(() => {
    let payload = `mode=${
      props?.retailerId ? "BRANCH" : "DEFAULT"
    }&branchCode=${props?.retailerId || undefined}`;
    setShowLoading(true);
    getConfig(payload).then((response) => {
      if (!isEmpty(response)) {
        setFormState(response);
        if (isEmpty(configData)) dispatchConfigState(response);
      }
    });
  }, [configData, dispatchConfigState, props, setShowLoading]);

  const getNewFormState = useCallback(
    (rowData = false) => {
      let temp = rowData ? [] : {};
      for (let fs in formState) {
        if (formState[fs] !== configData[fs]) {
          if (rowData) {
            temp.push({
              name: formLabels[fs]?.displayName,
              section: formLabels[fs]?.section,
              oldValue: formState[fs],
              newValue: configData[fs],
            });
          } else {
            temp[fs] = configData[fs];
          }
        }
      }
      return temp;
    },
    [configData, formLabels, formState]
  );

  const saveConfiguration = useCallback(
    async (force = false) => {
      let temp = getNewFormState();
      let data = configSavePayload(temp, props?.retailerId);
      let payload = {
        data,
        mode: props?.retailerId ? "BRANCH" : "DEFAULT",
        force,
      };
      saveConfig(payload).then((response) => {
        if (response.status === "success") {
          displayToast({
            type: "success",
            title: "Successfully saved.",
          });
          setFormState({});
        } else {
          delete response.result["need_force"];
          setShowErrorModal(response.result);
        }
      });
    },
    [getNewFormState, props?.retailerId]
  );
  const dispatchUpdateConfigState = useCallback(
    (payload) => {
      dispatch({ type: "update_config_data", payload });
    },
    [dispatch]
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceDispatchUpdateConfig = useCallback(
    _.debounce(dispatchUpdateConfigState, 1),
    []
  );
  const handleTextFormChange = (name, value, type) => {
    let data = [];
    let obj = {
      name: name,
      value: value,
      type: (typeof value).toString().toUpperCase(),
      groupName: type.toUpperCase(),
    };
    data.push(obj);
    // saveConfiguraion({ data: data });
  };
  const handleFormChange = useCallback(
    (name, value, groupName = "", isSelect, options) => {
      if (name === "SHOP_GST_NUMBER") {
        let gstinRegex = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
        if (!value?.trim().length || !gstinRegex.test(value)) {
          displayToast({
            type: "error",
            title: "Please enter a valid GSTIN",
          });
          return;
        } else {
          displayToast({
            type: "success",
            title: "GSTIN Valid.",
          });
        }
      }
      if (name === "MOBILE_NUMBER") {
        value = +value;
        if (value && !isValidPhoneNumber(value)) {
          displayToast({
            type: "error",
            title: "Please enter valid mobile Number",
          });
          return;
        }
      }
      if (name === "WHATSAPP_NUMBER") {
        if (value && !isValidPhoneNumber(value)) {
          displayToast({
            type: "error",
            title: "Please enter valid whatsapp Number",
          });
          return;
        }
      }
      if (name === "BACKUP_CRON") {
        if (!getStringValue(value) || value > 24) {
          return displayToast({
            type: "error",
            title: "Please enter a valid interval between 0 to 24",
          });
        }
      }
      if (name === "START_FIN_DATE" || name === "END_FIN_DATE"||name === "LICENSE_EXPIRY") {
        if (value.length === 10) {
          value = getISODateTime(value);
          if(name==="LICENSE_EXPIRY"){
            value=moment(value).format("YYYY-MM-DD");
           }
          if (name === "START_FIN_DATE") {
            value = moment(value).startOf("day").format("YYYY-MM-DD HH:mm:ss");
          }
          if (name === "END_FIN_DATE") {
            value = moment(value)
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss.SSS");
          }
        } else {
          return displayToast({
            type: "error",
            title: "Please enter a valid Date.",
          });
        }
      }
      // if (name === "EMAIL_ID") {
      //   const emailRegex =
      //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //   if (!emailRegex.test(value) && value.length) {
      //     displayToast({
      //       type: "error",
      //       title: "Please enter a valid Email ID",
      //     });
      //     return;
      //   }
      // }
      // let data = [];
      // let obj = {
      //   name: name,
      //   value: value,
      //   type: (typeof value).toString().toUpperCase(),
      //   groupName: groupName.toUpperCase(),
      // };
      // if (name === "START_FIN_DATE" || name === "END_FIN_DATE") {
      //   obj.type = toUpper(DATE);
      // }
      let obj = {};
      obj[name] = value;
      debounceDispatchUpdateConfig(obj);
      // data.push(obj);
      // saveConfiguraion({ data: data });
    },
    [debounceDispatchUpdateConfig]
  );
  const configClickHandler = useCallback(
    (configData) => {
      if (configData.id === 0 && !props?.retailerId)
        return displayToast({
          type: "warn",
          title: "Cannot change account settings in Default mode.",
        });
      setActiveConfigItem(configData);
      dispatch({
        type: "active_config_tab",
        payload: configData,
      });
    },
    [dispatch, props]
  );
  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const altKey = e.altKey;
      const ctrlKey = e.ctrlKey;
      if (altKey) {
        if (key === "1") {
          if (!props?.retailerId)
            return displayToast({
              type: "warn",
              title: "Cannot change account settings in Default mode.",
            });
          setActiveConfigItem({
            id: 0,
            label: "Account",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 0,
              label: "Account",
            },
          });
          return;
        }
        if (key === "2") {
          setActiveConfigItem({
            id: 1,
            label: "Sales",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 1,
              label: "Sales",
            },
          });
          return;
        }
        if (key === "3") {
          setActiveConfigItem({
            id: 2,
            label: "Purchase",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 2,
              label: "Purchase",
            },
          });
          return;
        }
        if (key === "4") {
          setActiveConfigItem({
            id: 3,
            label: "Return",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 3,
              label: "Return",
            },
          });
          return;
        }
        if (key === "5") {
          setActiveConfigItem({
            id: 4,
            label: "Integrations",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 4,
              label: "Integrations",
            },
          });
          return;
        }
        if (key === "6") {
          setActiveConfigItem({
            id: 5,
            label: "Other Settings",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 5,
              label: "Other Settings",
            },
          });
          return;
        }
        if (key === "7") {
          setActiveConfigItem({
            id: 6,
            label: "Email",
          });
          dispatch({
            type: "active_config_tab",
            payload: {
              id: 6,
              label: "Email",
            },
          });
          return;
        }
      }
      if (ctrlKey) {
        if (key === "s") {
          if (isEmpty(getNewFormState())) {
            displayToast({ type: "warn", title: "Nothing to save" });
          } else {
            setShowModal(true);
          }
        }
      }
    },
    [dispatch, getNewFormState, props]
  );

  useEffect(() => {
    if (activeConfigItem.id === 0 && !props.retailerId) {
      setActiveConfigItem({
        id: 1,
        label: "Sales",
      });
      dispatch({
        type: "active_config_tab",
        payload: {
          id: 1,
          label: "Sales",
        },
      });
    }
  }, [activeConfigItem, dispatch, props]);

  useEffect(() => {
    if (isEmpty(formState)) {
      getConfigDetails();
    }
  }, [formState, getConfigDetails]);
  useEffect(() => {
    if (
      !autocompleteOpen &&
      !showSpotlight &&
      !showHealthCards &&
      !commonModalOpen
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    autocompleteOpen,
    commonModalOpen,
    listener,
    showHealthCards,
    showSpotlight,
  ]);

  return (
    <>
      <div className={classes["configuration-main-section"]}>
        <div className={classes["configuration-main-header"]}>
          {props?.retailerId
            ? `${props?.retailerId} - ${formState.SHOP_NAME || ""} ${
                formState.SHOP_SHORT_ADDRESS || ""
              }`
            : "Default Configuration"}
        </div>
        <div className={classes["configuration-main-container"]}>
          <div className={classes["configuration-panel-container"]}>
            <ConfigurationPanel
              onConfigClick={configClickHandler}
              activeComponent={activeConfigItem}
              onSave={() => {
                if (isEmpty(getNewFormState())) {
                  displayToast({ type: "warn", title: "Nothing to save" });
                } else {
                  setShowModal(true);
                }
              }}
            />
          </div>
          {!isEmpty(configData) && !isEmpty(formLabels) && (
            <div className={classes["configuration-details-container"]}>
              <ConfigurationDetails
                activeComponent={activeConfigItem}
                handleTextFormChange={handleTextFormChange}
                handleFormChange={handleFormChange}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        header="Do you want to save the following changes"
        height="80%"
        open={showModal}
        onEscape={() => {
          setShowModal(false);
        }}
        onClose={() => {
          setShowModal(false);
        }}
      >
        <div className={classes["configuration-modal"]}>
          <Aggrid columnDefs={changedColDefs} rowData={getNewFormState(true)} />
          <div className={classes["add-role-ctas"]}>
            <Button
              label={"Save"}
              onClick={() => {
                setShowModal(false);
                saveConfiguration();
              }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        header="WARNING: Do you want to override the following changes"
        height="80%"
        open={!isEmpty(showErrorModal)}
        onEscape={() => {
          setShowErrorModal({});
        }}
        onClose={() => {
          setShowErrorModal({});
        }}
      >
        <div className={classes["configuration-modal"]}>
          <div style={{ overflow: "scroll", height: "100%" }}>
            {Object.keys(showErrorModal).map((er) => {
              if (showErrorModal[er].filter((val) => val.is_error).length) {
                return (
                  <div style={{ height: "35%" }}>
                    {er}:
                    <Aggrid
                      columnDefs={changedColDefs}
                      rowData={showErrorModal[er].filter((val) => val.is_error)}
                    />
                  </div>
                );
              } else {
                return <></>;
              }
            })}
          </div>
          <div className={classes["configuration-save-button"]}>
            <Button
              label={"Save"}
              onClick={() => {
                setShowErrorModal({});
                saveConfiguration(true);
              }}
            />
            <Button
              label={"Cancel"}
              onClick={() => {
                setShowErrorModal({});
                // saveConfiguration();
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Configuration;
